import React from 'react';

const Button = ({ 
  children, 
  type = 'button', 
  variant = 'primary', 
  size = 'default',
  fullWidth = false,
  disabled = false,
  loading = false,
  onClick,
  className = '',
  icon = null,
  iconPosition = 'left'
}) => {
  
  const baseStyles = 'font-medium transition-all duration-300 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed rounded-lg';
  
  const variants = {
    primary: `
      bg-amber-900 text-white 
      hover:bg-amber-800 hover:shadow-lg 
      focus:ring-amber-900 
      disabled:bg-gray-300 disabled:hover:bg-gray-300 disabled:hover:shadow-none
      active:scale-95
    `,
    secondary: `
      bg-gray-200 text-gray-800 
      hover:bg-gray-300 hover:shadow-md
      focus:ring-gray-400 
      disabled:bg-gray-100 disabled:text-gray-400
      active:scale-95
    `,
    outline: `
      border-2 border-amber-900 text-amber-900 bg-white
      hover:bg-amber-900 hover:text-white hover:shadow-md
      focus:ring-amber-900 
      disabled:border-gray-300 disabled:text-gray-300 disabled:hover:bg-white
      active:scale-95
    `,
    danger: `
      bg-red-600 text-white 
      hover:bg-red-700 hover:shadow-lg
      focus:ring-red-500 
      disabled:bg-gray-300
      active:scale-95
    `,
    ghost: `
      bg-transparent text-amber-900
      hover:bg-amber-900/10
      focus:ring-amber-900
      disabled:text-gray-300
    `
  };
  
  const sizes = {
    small: 'px-4 py-2 text-sm',
    default: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  const renderContent = () => {
    if (loading) {
      return (
        <>
          <div className="spinner-small mr-2"></div>
          <span>Loading...</span>
        </>
      );
    }
    
    if (icon && iconPosition === 'left') {
      return (
        <>
          <span className="mr-2">{icon}</span>
          {children}
        </>
      );
    }
    
    if (icon && iconPosition === 'right') {
      return (
        <>
          {children}
          <span className="ml-2">{icon}</span>
        </>
      );
    }
    
    return children;
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]}
        ${widthClass} 
        ${className}
      `}
    >
      {renderContent()}
    </button>
  );
};

export default Button;